import { render, staticRenderFns } from "./ManagerPackageSelector.vue?vue&type=template&id=2c332e0f&scoped=true"
import script from "./ManagerPackageSelector.vue?vue&type=script&lang=js"
export * from "./ManagerPackageSelector.vue?vue&type=script&lang=js"
import style0 from "./ManagerPackageSelector.vue?vue&type=style&index=0&id=2c332e0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c332e0f",
  null
  
)

export default component.exports